import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import loadScripts from '../../../dassets/js/custom';
class NextOfKin extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            nok_surname: this.refs.nok_surname.value,
            nok_first_name: this.refs.nok_first_name.value,
            nok_other_name: this.refs.nok_other_name.value,
            nok_relationship: this.refs.nok_relationship.value,
            nok_contact_add: this.refs.nok_contact_add.value,
            nok_phone: this.refs.nok_phone.value,
            nok_email: this.refs.nok_email.value
        }

        this.props.saveValues(data, 'next_of_kin')
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Next Of Kin Details (Account Holder 1)</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address<span className="text-danger">*</span></label>
                                            <Form.Control type="email" className="form-control" ref="nok_email" placeholder="Email Address" defaultValue={this.props.fieldValues.nok_email} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="nok_surname" placeholder="Surname" defaultValue={this.props.fieldValues.nok_surname} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="nok_first_name" placeholder="First Name" defaultValue={this.props.fieldValues.nok_first_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="nok_other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.nok_other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Relationship<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="nok_relationship" placeholder="Relationship" defaultValue={this.props.fieldValues.nok_relationship} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Contact Address<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="nok_contact_add" placeholder="Contact Address" defaultValue={this.props.fieldValues.nok_contact_add} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mobile No<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="nok_phone" placeholder="Mobile No" defaultValue={this.props.fieldValues.nok_phone} required />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NextOfKin;